import axios from 'axios';


const BASE_URL = process.env.REACT_APP_API_ENDPOINT;

const handleLogout = () => {
    localStorage.removeItem('currentUser')
    localStorage.removeItem('token')
    localStorage.removeItem('tabIndex')
    localStorage.clear();
    // Redirect to login page
    window.location.href = '/';
};

// Create an Axios instance
const api = axios.create({
    baseURL: BASE_URL,
    headers: {
        'Content-Type': 'application/json',
    },
});

// Add a request interceptor
api.interceptors.request.use(
    (config) => {
        // Get the token from localStorage
        const token = localStorage.getItem('token');

        // If the token exists, add it to the headers
        if (token) {
            config.headers.authorization = `Bearer ${token}`;
        }

        return config;
    },
    (error) => {
        // Handle the error
        return Promise.reject(error);
    }
);

const handle401Error = (error) => {
    if (error.response && error.response.status === 401) {
        handleLogout();
    }
    return Promise.reject(error);
};

// Add response interceptor to api instance
api.interceptors.response.use(
    (response) => response,
    handle401Error
);

// For multipart/form-data requests
const formApi = axios.create({
    baseURL: BASE_URL,
    headers: {
        'Content-Type': 'multipart/form-data',
    },
});

// Add a request interceptor to formApi
formApi.interceptors.request.use(
    (config) => {
        // Get the token from localStorage
        const token = localStorage.getItem('token');

        // If the token exists, add it to the headers
        if (token) {
            config.headers.authorization = `Bearer ${token}`;
        }

        return config;
    },
    (error) => {
        // Handle the error
        return Promise.reject(error);
    }
);

// Add response interceptor to api instance
formApi.interceptors.response.use(
    (response) => response,
    handle401Error
);

const SettingHandler = {

    async doHandlerSetting(payload) {
        try {
            const { data } = await api.patch(`audio/settings`, payload);
            return data;
        } catch (error) {
            return error;
        }
    },
    async doGetSetting() {
        try {
            const { data } = await api.get(`audio/settings`);
            return data;
        } catch (error) {
            return error;
        }
    },

    async doHandlerChangePassword(payload) {
        try {
            const { data } = await api.post(`auth/change-password`, payload);
            return data;
        } catch (error) {
            return error;
        }
    },

    async doHandlerResetPassword(token, payload) {
        try {
            const { data } = await api.put(`auth/password/reset/${token}`, payload);
            // const { data } = await api.put(`http://172.16.17.119:3000/password/reset/${token}`, payload);
            return data;
        } catch (error) {
            return error;
        }
    },

    async doHandlerForgotPassword(payload) {
        try {
            const { data } = await api.post(`auth/password/forgot`, payload);
            return data;
        } catch (error) {
            return error;
        }
    },

    async doHandlerGetUserDeviceInfo() {
        try {
            const { data } = await api.get(`${BASE_URL}history/getUserDeivceInfo`);
            return data;
        } catch (error) {
            return error
        }
    },

    // Registers this browser's FCM token so the transcription webhook can push to it.
    async doRegisterDeviceToken(payload) {
        try {
            const { data } = await api.post(`auth/device`, payload);
            return data;
        } catch (error) {
            return error;
        }
    },

    async doHandleUserAccountEmail(payload) {
        try {
            const { data } = await api.patch(`${BASE_URL}auth/change/email`, payload);
            return data;
        } catch (error) {
            return error;
        }
    },
}

export default SettingHandler